import { rateLimitedDetail, type IRateLimitedDetail } from '@d-orca/shared/client/apis';

/**
 * A request the server refused for coming too fast (429 RATE_LIMITED). The
 * call site still gets the response and fails as it always has; this event
 * lets one app-wide notice tell the user WHY, since a page's own "save failed"
 * copy can't. Dispatched by `authedFetch` the way `dorca:auth-expired` is.
 */
export const RATE_LIMITED_EVENT = 'dorca:rate-limited';

export function notifyRateLimited(res: Response): void {
  window.dispatchEvent(new CustomEvent<IRateLimitedDetail>(RATE_LIMITED_EVENT, { detail: rateLimitedDetail(res) }));
}
